import { useEffect, useState, useMemo } from 'react';
import TabPanel from '../tab-panel/tab-panel';
import Table from '../table/table';
import TabsList from '../tabs-list/tabs-list';
import ActionList from '../action-list/action-list';
import TableSummary from '../table-summary/table-summary';
import MainHead from '../main-head/main-head';
import PlanAction from '../planAction/PlanAction';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import AlertInformation from '../alert-information/alert-information';
import { selectCurrentUser } from 'src/modules/users/selector';
import Loading from 'src/components/Loading';
import { getColumns } from '../../store/columns/selectors';
import { fetchColumnsRequest } from '../../store/columns/columns';
import { getCurrentDate } from '../../store/date/selectors';
import { fetchCurrentDateRequestVPO } from '../../store/date/date';
import { getCurrentMonthAndYear, isNotStartedQuestionnaire, hasNoAction } from '../../utils/utils';
import { getDataMain, getFetchingStatusMainData } from '../../store/data-main/selectors';
import { fetchDataMainRequestVPO, createQuestionnaireRequestVPO, updateQuestionnaireRequestVPO } from '../../store/data-main/data-main';
import { fetchDataSummaryRequestVPO } from '../../store/data-summary/data-summary';
import { getDataSummary, getFetchingStatusMainSummary } from '../../store/data-summary/selectors';
import { months } from '../../const';
import { useSearchParams } from 'react-router-dom';

function MainPanel() {
  const [value, setValue] = useState(0);

  const [isModalOpenСomplete, setIsModalOpenСomplete] = useState<boolean>(false);
  const [isModalOpenReturn, setIsModalOpenReturn] = useState<boolean>(false);

  const [group, setGroup] = useState<{ [key: string]: string | number } | null>(null);
  const [factory, setFactory] = useState<{ [key: string]: string | number }>({});
  const [currentColumn, setCurrentColumn] = useState<{ [key: string]: string | number } | null>(null);
  const [lastColumn, setLastColumn] = useState<{ [key: string]: string | number } | null>(null);

  const [year, setYear] = useState<number | null>(null);
  const [month, setMonth] = useState<number | null>(null);

   const [searchParams] = useSearchParams();

  const columns = useAppSelector(getColumns);
  const currentDate = useAppSelector(getCurrentDate);
  const dataMain = useAppSelector(getDataMain);
  const loadingDataMain = useAppSelector(getFetchingStatusMainData);
  const dataSummary = useAppSelector(getDataSummary);
  const loadingDataSummary = useAppSelector(getFetchingStatusMainSummary)

  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => selectCurrentUser(state));

  const context: any = {
    currentMonth: month,
    currentYear: year,
    factory: factory,
    group: group,
    currentColumn: lastColumn,
    columns: columns
  };

  const isDisableQuestionnaire = useMemo(() => {
    if (user.infoVPO.adminRegion || user.infoVPO.zone) return;

    if (user.infoVPO.user || user.infoVPO.admin) {
      return user.infoVPO.factory.every((item) => item.factoryTitle !== factory.name);
    }
  }, [user, factory]);

  //! Проверка логики для аудитов
  const isLockedForAudit = useMemo(() => {
    if (user?.infoVPO?.adminRegion || user?.infoVPO?.zone) return false;
    if (!currentDate || !Array.isArray(currentDate) || !factory?.id || !currentColumn?.id || !month || !year) return false;

    const monthName = months[month - 1];
    const questionnaire = currentDate.find((item: any) => item.month === monthName && item.year === year);
console.log('questionnaire',questionnaire)
    if (!questionnaire || !questionnaire.isAudit || questionnaire.isAudit.length === 0) return false;

    return questionnaire.isAudit.some((audit: any) =>
      audit.vpo_factory?.id === factory.id && audit.vpo_column?.id === currentColumn.id
    );
  }, [currentDate, factory, currentColumn, month, year, user]);

  //! когда идет аудит, вместо "завершить оценку" - замок с тултип
  const showAuditLockIcon = useMemo(() => {
    if (!currentDate || !Array.isArray(currentDate) || !factory?.id || !currentColumn?.id || !month || !year) return false;

    const monthName = months[month - 1];
    const questionnaire = currentDate.find((item: any) => item.month === monthName && item.year === year);

    if (!questionnaire || !questionnaire.isAudit || questionnaire.isAudit.length === 0) return false;

    return questionnaire.isAudit.some((audit: any) =>
      audit.vpo_factory?.id === factory.id && audit.vpo_column?.id === currentColumn.id
    );
  }, [currentDate, factory, currentColumn, month, year]);

  // Устанавливаем текущий год и месяц после запроса
  useEffect(() => {
    if (currentDate && !searchParams.get(`actionCardVPO`)) {
      const date = getCurrentMonthAndYear(currentDate);
      setYear(date?.year);
      setMonth(date?.month)
    }
  }, [currentDate]);

  // Загружаем колонны
  useEffect(() => {
    dispatch(fetchColumnsRequest({ group: 1 }));
  }, [dispatch]);

  // Устанавливаем при первом рендере текущее направление
  useEffect(() => {
    if (columns && columns.length > 0 && value === 0) {
      setCurrentColumn(columns[0]);
      setValue(columns[0].index ?? 0);
      setLastColumn(columns[0]);
    }
  }, [columns]);

  useEffect(() => {
    dispatch(fetchCurrentDateRequestVPO());
  }, [dispatch]);

  // Получаем данные для опросников
  useEffect(() => {
    if (currentColumn?.id && factory?.id && group?.id && month !== null && year !== null) {
      dispatch(fetchDataMainRequestVPO({
        group: group.id,
        factory: factory.id,
        month: month,
        year: year,
        column: currentColumn.id,
      }));
    }
  }, [factory, month, year, currentColumn, dispatch]);

  // Получаем данные для сводки
  useEffect(() => {
    if (value === 1 && group?.id && factory?.id && month !== null && year !== null ) {
      dispatch(fetchDataSummaryRequestVPO({
        group: group.id,
        factory: factory.id,
        month: month,
        year: year,
        group: group.id
      }));
    }
  }, [value, group, factory, year, month, dispatch]);

  if (dataSummary) console.log('dataSummary', dataSummary)
  console.log('currentColumn', currentColumn)

  const handleTabChange = (newValue: { [key: string]: string | number }) => {
    setCurrentColumn(newValue);
    setValue(newValue.index as number);
    if (newValue.id) {
      setLastColumn(newValue);
    }
  };

  // Устанавливаем статус 'В процессе' для не начатого опросника
  const handleCreateQuestionnaire = () => {
    if (dataMain?.statusQuestionnaire.title === 'Не начато') {
      dispatch(createQuestionnaireRequestVPO({
        factory: factory.id as number,
        column: currentColumn.id as number,
        Month: month as number,
        Year: year as number,
        statusQuestionnaire: 'В процессе',
        IsError: hasNoAction(dataMain?.data),
      }))
    } else {
      dispatch(updateQuestionnaireRequestVPO({
        id: dataMain?.statusQuestionnaire.id,
        statusQuestionnaire: 'В процессе',
        IsError: hasNoAction(dataMain?.data),
      }));
    }
  }

  // Завершение опросника
  const handleСompleteQuestionnaire = () => {
    if (dataMain?.statusQuestionnaire.title === 'Не начато') {
      dispatch(createQuestionnaireRequestVPO({
        factory: factory.id as number,
        column: currentColumn.id as number,
        Month: month as number,
        Year: year as number,
        statusQuestionnaire: 'Завершено',
        IsError: hasNoAction(dataMain?.data),
        completionDate: new Date().toISOString(),
        AuthorEnd: user.displayName
      }))
    } else {
      dispatch(updateQuestionnaireRequestVPO({
        id: dataMain?.statusQuestionnaire.id,
        statusQuestionnaire: 'Завершено',
        IsError: hasNoAction(dataMain?.data),
        completionDate: new Date().toISOString(),
        AuthorEnd: user.displayName
      }));
    }

    setIsModalOpenСomplete(false);
  }

  // Возвращение опросника в работу
  const handleReturnQuestionnaire = () => {
    dispatch(updateQuestionnaireRequestVPO({
      id: dataMain?.statusQuestionnaire.id,
      statusQuestionnaire: 'В процессе',
      completionDate: null as any,
      AuthorEnd: '',
    }));

    setIsModalOpenReturn(false);
  }

  const handleOpenModalСomplete = () => {
    setIsModalOpenСomplete(true);
  }

  const handleCloseModalСomplete = () => {
    setIsModalOpenСomplete(false);
  }

  const handleOpenModalReturn = () => {
    setIsModalOpenReturn(true);
  }

  const handleCloseModalReturn = () => {
    setIsModalOpenReturn(false);
  }

  return (
    <div className={`${value !== 8 ? 'max-h-[100vh] overflow-y-hidden' : ''}`}>
      <MainHead group={group} factory={factory} onGroupChange={setGroup} onFactoryChange={setFactory} user={user} setMonth={setMonth} setYear={setYear} columns={columns} onColumnChange={handleTabChange} hideSelects={value === 2} />

      <div className='p-7.5'>
        {currentColumn && <TabsList isFixed data={columns} value={currentColumn} onChange={handleTabChange} />}

        <TabPanel value={value} index={0}>
          {dataMain &&
            <ActionList
              year={year as number}
              setYear={setYear}
              month={month as number}
              setMonth={setMonth}
              statusQuestionnaire={dataMain.statusQuestionnaire.title}
              isNotEditQuestionnaire={isDisableQuestionnaire as boolean}
              isLockedForAudit={showAuditLockIcon}
              currentDate={currentDate}
              user={user}
              dataMain={dataMain.data}
              departments={dataMain.dataHead}
              column={currentColumn}
              isNotAction={hasNoAction(dataMain?.data)}
              onButtonComplete={handleOpenModalСomplete}
              onButtonReturn={handleOpenModalReturn}
            />
          }

          {loadingDataMain
            ?
            <div className='grid place-items-center min-h-[25vh]'>
              <Loading />
            </div>
            :
            <>
              {dataMain &&
                <Table
                  data={dataMain.data}
                  dataHead={dataMain.dataHead}
                  answerContext={{factory: factory.id, year, month, group: group?.id, column: currentColumn?.id, isEditNA: user.infoVPO.userEditNA}}
                  isEvent
                  isNotEditQuestionnaire={dataMain.statusQuestionnaire.title === "Завершено" || isDisableQuestionnaire || isLockedForAudit}
                  context={context}
                  onCreateQuestionnaire={handleCreateQuestionnaire}
                />
              }
            </>
          }
        </TabPanel>

        <TabPanel value={value} index={1}>
          <ActionList
            year={year as number}
            setYear={setYear}
            month={month as number}
            setMonth={setMonth}
            dataMain={dataSummary?.data}
            departments={dataSummary?.dataHead}
            currentDate={currentDate}
            custom
          />

          {loadingDataSummary
            ?
            <div className='grid place-items-center min-h-[25vh]'>
              <Loading />
            </div>
            :
            <>
              {dataSummary &&
                <TableSummary
                  data={dataSummary?.data}
                  dataHead={dataSummary?.dataHead}
                  category='default'
                  isCompleted
                />
              }
            </>
          }
        </TabPanel>

        <TabPanel value={value} index={2}>
          <PlanAction
          context={context} />
        </TabPanel>
      </div>

      <AlertInformation
        isOpen={isModalOpenReturn}
        custom
        title="Подтвердите действие"
        text="Вы уверены, что хотите вернуть опросник в работу? Все сотрудники, у которых есть доступ к опроснику, смогут его изменить и завершить."
        textConfirmButton="Да, вернуть в работу"
        onClose={handleCloseModalReturn}
        onConfirm={handleReturnQuestionnaire}
      />

      {dataMain &&
        <AlertInformation
          isOpen={isModalOpenСomplete}
          custom
          title='Подтвердите действие'
          text="Вы уверены, что хотите завершить оценку? Ответы нельзя будет изменить после завершения оценки."
          danger={`${hasNoAction(dataMain?.data) ? "Остались ответы “НЕТ”, к которым еще не добавлены действия. Ответы нельзя будет изменить после завершения оценки." : ""}`}
          textConfirmButton="Да, завершить"
          onClose={handleCloseModalСomplete}
          onConfirm={handleСompleteQuestionnaire}
        />
      }
    </div>
  );
}

export default MainPanel;
